import { api } from './context';

export const sendRequest = async (route, urlPathParam = '', body = {}, config = {}, paramsList = [], axiousInstance = api) => {
    const { method, path, action, isRodx } = route;
    const queryParams = paramsList.filter((p) => p != null && p.length).join('&');
    const basePath = isRodx ? '/rodx' : '';
    const urlParamPart = urlPathParam?.length ? `/${urlPathParam}` : '';
    const actionPart = action ? action : '';
    const queryPart = queryParams.length ? `?${queryParams}` : '';
    const fullPath = `${basePath}${path}${urlParamPart}${actionPart}${queryPart}`;

    return await axiousInstance[method](fullPath, body, config);
};

export const sendBasicRequest = async (method, url, body = {}, config = {}, axiousInstance = api) => {
    return await axiousInstance[method](url, body, config);
};